export enum SendConfirmationLocation {
    TelecomSimulations = 'telecom-simulations',
    EnergySimulations = 'energy-simulations',
    ContractingFlow = 'contract-flow',
    Dashboard = 'dashboard',
}
